module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-request"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "maxRowspan": _vm.maxRowspan,
      "indexDisp": true,
      "requestDisp": true,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent,
      "requestCancelDisp": false,
      "nowLang": _vm.nowLang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe1d7b2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableRequest.vue
// module id = 4020
// module chunks = 1